module.exports = __webpack_public_path__ + "static/media/codropsicons.70b87227.woff";